const set_de = {
  title: 'Artikelset erstellen',
  back: 'Zurück',
  groupView: 'Gruppenansicht',
  listView: 'Listenansicht',
  widthDepthHeight: 'Breite x Tiefe x Höhe',
  uncategorized: 'Nicht kategorisiert',
  untagged: 'Ohne Tag',
  table: {
    name: 'Name',
    category: 'Kategorie',
    subCategory: 'Unterkategorie',
    minimumStock: 'Mindestbestand'
  },
  form: {
    title: 'Neues Set erstellen',
    editTitle: 'Artikelset bearbeiten',
    name: 'Set-Name',
    namePlaceholder: 'Set-Namen eingeben',
    tagRequired: 'Tag ist erforderlich',
    selectedItems: 'Ausgewählte Artikel',
    reset: 'Zurücksetzen',
    createSet: 'Set erstellen',
    editSet: 'Set bearbeiten',
    setUpdated: 'Set wurde aktualisiert',
    setCreated: 'Set wurde erstellt',
    setCreateError: 'Set konnte nicht erstellt werden',
    setUpdateError: 'Set konnte nicht aktualisiert werden',
    noItemsSelected: 'Bitte wählen Sie mindestens einen Artikel aus, bevor Sie ein Set erstellen',
    removeItem: 'Artikel entfernen',
    image: 'Set-Bild',
    chooseImage: 'Bild auswählen',
    replaceImage: 'Bild ersetzen',
    removeImage: 'Bild entfernen',
    imageHint: 'Ohne eigenes Bild zeigt das Set die Bilder seiner Artikel.',
    imageSaveError: 'Das Set wurde gespeichert, das Bild aber nicht.',
    imageUnreadable: 'Diese Datei ist kein lesbares Bild. Bitte ein JPG, PNG oder WebP wählen.'
  },
  delete: {
    title: 'Artikelset löschen',
    body: 'Sind Sie sicher, dass Sie dieses Set löschen möchten?',
    delete: 'Löschen',
    cancel: 'Abbrechen'
  },
  list: {
    title: 'Sets',
    search: 'Suche',
    editSet: 'Set bearbeiten',
    deleteSet: 'Set löschen',
    noItems: 'Keine Artikel gefunden'
  },
  detail: {
    title: 'Artikelset-Details',
    setName: 'Set-Name',
    setItems: 'Set-Artikel',
    close: 'Schließen',
    edit: 'Bearbeiten',
    delete: 'Löschen'
  }
}

export default set_de
